<template>
  <!--
    El listado se reutiliza al cambiar de página, búsqueda o filtro (los lee de la ruta);
    el resto de pantallas (perfil, importación) se recrean con cada ruta.
  -->
  <router-view :key="$route.name === 'users' ? 'users-list' : $route.fullPath"></router-view>
</template>

<script>
export default {
  name: "UsersComponent",
}
</script>
